function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useScroll, useTransform } from "framer-motion";
// @REAMDE takes a ref and returns 2 motion values
// the first one being the positive parallax - normalized between -1 and 1 with 0 being equivalent to the element being in the middle of the screen
// the second one is the inverse of the first one - between 1 and -1 for an inverse effect
export function useParallax(ref) {
    var scrollOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        "start end",
        "end start"
    ], otherOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var scrollYProgress = useScroll(_objectSpread({
        target: ref,
        offset: scrollOffset
    }, otherOptions)).scrollYProgress;
    var ty = useTransform(scrollYProgress, function(progress) {
        // normalize between -1 and 1 -> with 0 being equivalent to 0.5
        var normalized = progress * 2 - 1;
        return normalized;
    });
    var invty = useTransform(ty, function(value) {
        return -value;
    });
    return [
        ty,
        invty
    ];
}

//# sourceMappingURL=useParallax.js.map